var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/interestUnselected.371985ad.png","uri@2x": __webpack_public_path__ + "static/media/interestUnselected.48a57529.png","uri@3x": __webpack_public_path__ + "static/media/interestUnselected.a8ea7064.png",
    width: 21,
    height: 21
});